import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { computed, observable, action } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { ResponsiveEventHandler } from '../../shared/WindowResizeHandler';
import { IResponsiveSizeType } from '../../../models/responsive';
import { splitApp } from '../../../utils/appSplit';
import { ISplitAppInputs } from '../../../models/app/ISplitAppInputs';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';
/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	responsiveEventHandler: ResponsiveEventHandler;
	@observable.ref breakpointDefinitions: {
		[key: string]: number;
	}[] = [];
	@observable.ref screenSize: IResponsiveSizeType;

	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
		this.breakpointDefinitions = [
			{ xsmall: 0 }, // all mobile devices
			{ small: 576 }, // mobile devices (not sure which one's this big)
			{ medium: 768 }, // ipad, ipad pro, ipad mini, etc
			{ large: 992 }, // smaller laptops
			{ xlarge: 1200 }, // laptops and desktops
		];
		this.screenSize = 'xsmall';
		this.updateScreenSize = this.updateScreenSize.bind(this);
		this.responsiveEventHandler = new ResponsiveEventHandler({
			defaultSizeType: this.screenSize,
			wait: 250,
			sizes: this.breakpointDefinitions,
			onSizeChange: this.updateScreenSize,
		});
		if (!(window as any)['__ksysSplitAppFunctions__']) {
			(window as any)['__ksysSplitAppFunctions__'] = {};
		}
		if (manifest.packageName) {
			(window as any)['__ksysSplitAppFunctions__'][manifest.packageName] = splitApp;
		}
	}

	@action
	public updateScreenSize(size: IResponsiveSizeType) {
		this.screenSize = size;
	}

	@computed
	get hasData(): boolean {
		return this.storeContext.tableStore.hasData === true;
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get splitAppOptions() {
		const inputs = (this.appParamsHelper.inputs || {}) as ISplitAppInputs;
		const limit = parseInt(inputs.limit || '0', 10);
		const start = parseInt(inputs.start || '0', 10);
		return {
			limit,
			start,
			inputs,
			hideDisclaimer: inputs.hasDisclaimers === 'false',
			hideCardHeader: inputs.hasCardHeader === 'false',
			hideRows: start === -1 || limit === 0,
			mustLimitRows: start || limit,
		};
	}

	async customInitializeAfter() {
		const { tableStore } = this.storeContext;
		await tableStore.initialize();
	}

}